/* Remove counts enclosed in parentheses (e.g., "(123)" or "(1,234)") from the input string.
 * Note: Converting input parameter to string to ensure consistent behavior and prevent runtime errors.
 */
export const removeCount = (title: string): string => {
  if (!title) {
    return "";
  }

  const titleStr = String(title);

  const matches = titleStr.match(/\(\d+(,\d{3})*\)/g);

  if (!matches || matches.length === 0) {
    return titleStr;
  }

  if (matches.length === 1) {
    return titleStr
      .replace(/^\(\d+(,\d{3})*\)\s*/, "")
      .replace(/\s*\(\d+(,\d{3})*\)$/, "")
      .trim();
  } else {
    return titleStr.replace(/^\(\d+(,\d{3})*\)\s*/, "").trim();
  }
};
